import { render } from "./eventMessage.vue?vue&type=template&id=7caec5c3&scoped=true"
import script from "./eventMessage.vue?vue&type=script&lang=js"
export * from "./eventMessage.vue?vue&type=script&lang=js"

import "./eventMessage.vue?vue&type=style&index=0&id=7caec5c3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7caec5c3"

export default script